import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import PublicView from '../pages/public/index.vue'

// Admin pages
import Customer from 'src/pages/Customer.vue'
import UserAdmin from 'src/pages/UserAdmin.vue'
import customerAccess from 'src/pages/CustomerAdmin.vue'
import Login from 'src/pages/Login.vue'
import PublicLogin from 'src/pages/Login.vue'

import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'

const routes = [
  {
    path: '/',
    component: PublicView,
    // redirect: '/admin/overview'
  },
  {
    path: '/publiclogin',
    component: PublicLogin,
  },
  {
    path: '/login',
    component: Login,
  },
  
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/customer',
    children: [
      {
        path: 'customer',
        name: 'Customer',
        component: Customer,
        meta: { requiresAuth: true }
      },
      {
        path: 'user',
        name: 'user',
        component: UserAdmin,
        meta: { requiresAuth: true }
      },
      {
        path: 'customerAccess',
        name: 'customerAccess',
        component: customerAccess,
        meta: { requiresAuth: true }
      }
      
      // {
      //   path: 'overview',
      //   name: 'Overview',
      //   component: Overview
      // },
      // {
      //   path: 'user',
      //   name: 'User',
      //   component: UserProfile
      // },
      // {
      //   path: 'table-list',
      //   name: 'Table List',
      //   component: TableList
      // },
      // {
      //   path: 'typography',
      //   name: 'Typography',
      //   component: Typography
      // },
      // {
      //   path: 'icons',
      //   name: 'Icons',
      //   component: Icons
      // },
      // {
      //   path: 'maps',
      //   name: 'Maps',
      //   component: Maps
      // },
      // {
      //   path: 'notifications',
      //   name: 'Notifications',
      //   component: Notifications
      // },
      // {
      //   path: 'upgrade',
      //   name: 'Upgrade to PRO',
      //   component: Upgrade
      // }
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
